import PainAssessment from '@pages/Home/PainAssessment';

export default function AiVirtualAssessment() {
	return (
		<>
			<div style={{margin: '1.25rem'}}>
				<div style={{margin: '1.25rem'}}>
					<PainAssessment />
				</div>
			</div>
		</>
	);
}
